import { render, staticRenderFns } from "./ContentButtons.vue?vue&type=template&id=2c28e0da&"
import script from "./ContentButtons.vue?vue&type=script&lang=js&"
export * from "./ContentButtons.vue?vue&type=script&lang=js&"
import style0 from "./ContentButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports